import { log } from '@/utils/log';

/** Remove the unpartitioned cache left by earlier service workers. Private API data is now network-only. */
export async function clearPrivateApiCache(): Promise<void> {
    if (typeof caches === 'undefined') return;
    try {
        await caches.delete('api-cache');
    } catch (error) {
        log('Could not remove the legacy private API cache:', error);
    }
}
